import React from "react";
import PropTypes from "prop-types";

function CheckBox({ children, name, register, ...rest }) {
  return (
    <div className="field">
      <div className="control">
        <label htmlFor={name}>
          <input
            {...rest}
            name={name}
            id={name}
            type="checkbox"
            className="styled-checkbox"
            ref={register}
          />
          {children}
        </label>
      </div>
    </div>
  );
}

CheckBox.propTypes = {
  children: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  register: PropTypes.func.isRequired,
};

export default CheckBox;
